export const shortFAQ = [
  {
    title: "¿Cuáles son los requisitos?",
    htmlContent:
      "Nuestra certificación es multinivel, por lo que no necesitas conocimientos técnicos previos para tomarla. Sin embargo, para aprovechar mejor el proceso, te recomendamos tener familiaridad con el ejercicio y realizar actividad física de forma regular.",
  },
  {
    title:
      "¿Cuál es la diferencia entre las certificaciones on demand y las certificaciones en vivo?",
    htmlContent: `
                  <div>
                    <b>On demand</b>
                    <p>En esta modalidad estudias a tu ritmo, en tus propios tiempos y desde donde estés. Puedes elegir entre las siguientes opciones:</p>
                    <ul>
                      <li>Sculpt &amp; Burn</li>
                      <li>Sculpt &amp; Burn + Barre</li>
                      <li>Sculpt &amp; Burn + Barre + Block Burn Pilates</li>
                    </ul>
                    <b>En vivo</b>
                    <p>Esta modalidad incluye las 3 disciplinas: Sculpt &amp; Burn, Barre y Block Burn Pilates. Comienza con 3 días de certificación en vivo (viernes, sábado y domingo), donde podrás aprender de forma más cercana, recibir correcciones en directo y resolver dudas al momento. Puede tomarse de forma presencial o vía Zoom, e incluye 80 días de acceso a la plataforma on demand para complementar y reforzar tu aprendizaje.</p>
                  </div>`,
  },
  {
    title: "¿Qué equipo necesito para tomar la certificación?",
    htmlContent: `
                  <div>
                  <p>La mayor parte del equipo es opcional y puede adaptarse según tu nivel y el material que tengas disponible en casa. El único material obligatorio para Block Burn Pilates son los 2 blocks de corcho con medidas de 10 x 15 x 22 cm.</p>
                  <b>On demand — Sculpt &amp; Burn</b>
                  <ul>
                    <li>Mancuernas de 3 lbs</li>
                    <li>Mancuernas de 5 lbs</li>
                    <li>Mancuernas de 8 lbs</li>
                    <li>Mancuernas de 10 lbs</li>
                    <li>Banda de resistencia circular</li>
                    <li>Tapete</li>
                    <li>Polainas de 2 kg cada una (opcionales)</li>
                  </ul>
                  <b>On demand — Sculpt &amp; Burn + Barre</b>
                  <ul>
                    <li>Mancuernas de 3, 5, 8 y 10 lbs</li>
                    <li>Banda de resistencia circular</li>
                    <li>Tapete</li>
                    <li>Mini ball de pilates sin peso (aprox. 25 cm de diámetro)</li>
                    <li>Barra o una superficie estable donde puedas apoyarte</li>
                    <li>Polainas de 2 kg cada una (opcionales)</li>
                    <li>Liga larga de látex (opcional)</li>
                  </ul>
                  <b>On demand — Sculpt &amp; Burn + Barre + Block Burn Pilates</b>
                  <ul>
                    <li>Mancuernas de 3, 5, 8 y 10 lbs</li>
                    <li>Banda de resistencia circular</li>
                    <li>Tapete</li>
                    <li>Mini ball de pilates sin peso (aprox. 25 cm de diámetro)</li>
                    <li>Barra o una superficie estable donde puedas apoyarte</li>
                    <li>Polainas de 2 kg cada una (opcionales)</li>
                    <li>2 blocks de corcho (obligatorios) de 10 x 15 x 22 cm</li>
                    <li>Liga larga de látex (opcional)</li>
                  </ul>
                  <b>En vivo (vía Zoom o parte on demand)</b>
                  <ul>
                    <li>Mancuernas de 3, 5, 8 y 10 lbs</li>
                    <li>Banda de resistencia circular</li>
                    <li>Tapete</li>
                    <li>Mini ball de pilates sin peso (aprox. 25 cm de diámetro)</li>
                    <li>Barra o una superficie estable donde puedas apoyarte</li>
                    <li>Polainas de 2 kg cada una (opcionales)</li>
                    <li>2 blocks de corcho (obligatorios) de 10 x 15 x 22 cm</li>
                    <li>Liga larga de látex (opcional)</li>
                  </ul>
                  <p>Si tomas los 3 días en vivo de forma presencial en nuestro estudio, nosotras te prestamos todo el equipo durante ese fin de semana.</p>
                  </div>
                `,
  },
  {
    title: "¿En donde puedo tomar las certificaciones On Demand?",
    htmlContent:
      "Desde cualquier dispositivo electrónico que cuente con acceso a WIFI como: Android, iphone, laptop, ipad y smart TV.",
  },
];
export const extendedFAQ = [
  {
    title: "¿Cuáles son los requisitos?",
    htmlContent:
      "Nuestra certificación es multinivel, por lo que no necesitas conocimientos técnicos previos para tomarla. Sin embargo, para aprovechar mejor el proceso, te recomendamos tener familiaridad con el ejercicio y realizar actividad física de forma regular.",
  },
  {
    title:
      "¿Cuál es la diferencia entre las certificaciones on demand y las certificaciones en vivo?",
    htmlContent: `
                  <div>
                    <b>On demand</b>
                    <p>En esta modalidad estudias a tu ritmo, en tus propios tiempos y desde donde estés. Puedes elegir entre las siguientes opciones:</p>
                    <ul>
                      <li>Sculpt &amp; Burn</li>
                      <li>Sculpt &amp; Burn + Barre</li>
                      <li>Sculpt &amp; Burn + Barre + Block Burn Pilates</li>
                    </ul>
                    <b>En vivo</b>
                    <p>Esta modalidad incluye las 3 disciplinas: Sculpt &amp; Burn, Barre y Block Burn Pilates. Comienza con 3 días de certificación en vivo (viernes, sábado y domingo), donde podrás aprender de forma más cercana, recibir correcciones en directo y resolver dudas al momento. Puede tomarse de forma presencial o vía Zoom, e incluye 80 días de acceso a la plataforma on demand para complementar y reforzar tu aprendizaje.</p>
                  </div>`,
  },
  {
    title: "¿Para quién es esta certificación?",
    htmlContent: `
        <div>
            <li>Alumnas que quieran perfeccionar su técnica y profundizar en su práctica.</li>
            <li>Personas que quieran formarse como coaches y generar ingresos haciendo lo que aman.</li>
            <li>Coaches que busquen ampliar sus conocimientos y fortalecer su metodología de enseñanza.</li>
            <li>Emprendedoras interesadas en abrir o desarrollar su propio negocio dentro de la industria del wellness.</li>
            <li>Profesionales del bienestar y la salud, como fisioterapeutas, psicólogas y nutriólogas, que quieran complementar su formación.</li>
            <li>Personas que busquen transformar sus hábitos y construir una mejor relación con el ejercicio.</li>
        </div>
    `,
  },
  {
    title: "¿Como y cuando recibo acceso a la certificación?",
    htmlContent: `
        <div>
        <b>Certificaciones on demand</b>
        <p>Al momento de realizar tu inscripción y pago, tu acceso a la certificación se activa automáticamente. Puedes iniciar de inmediato al completar tu compra.</p>
        <b>Certificaciones en vivo</b>
        <p>El acceso se confirma una vez liquidada tu inscripción, lo cual debe realizarse al menos 7 días antes de la certificación en vivo. Siete días antes del inicio, se crea un grupo de WhatsApp donde compartimos toda la información detallada sobre el fin de semana. Al concluir los 3 días de certificación en vivo, activamos tu acceso a la modalidad on demand, disponible durante 80 días.</p>
      </div>`,
  },
  {
    title: "¿Qué equipo necesito para tomar la certificación?",
    htmlContent: `
                  <div>
                  <p>La mayor parte del equipo es opcional y puede adaptarse según tu nivel y el material que tengas disponible en casa. El único material obligatorio para Block Burn Pilates son los 2 blocks de corcho con medidas de 10 x 15 x 22 cm.</p>
                  <b>On demand — Sculpt &amp; Burn</b>
                  <ul>
                    <li>Mancuernas de 3 lbs</li>
                    <li>Mancuernas de 5 lbs</li>
                    <li>Mancuernas de 8 lbs</li>
                    <li>Mancuernas de 10 lbs</li>
                    <li>Banda de resistencia circular</li>
                    <li>Tapete</li>
                    <li>Polainas de 2 kg cada una (opcionales)</li>
                  </ul>
                  <b>On demand — Sculpt &amp; Burn + Barre</b>
                  <ul>
                    <li>Mancuernas de 3, 5, 8 y 10 lbs</li>
                    <li>Banda de resistencia circular</li>
                    <li>Tapete</li>
                    <li>Mini ball de pilates sin peso (aprox. 25 cm de diámetro)</li>
                    <li>Barra o una superficie estable donde puedas apoyarte</li>
                    <li>Polainas de 2 kg cada una (opcionales)</li>
                    <li>Liga larga de látex (opcional)</li>
                  </ul>
                  <b>On demand — Sculpt &amp; Burn + Barre + Block Burn Pilates</b>
                  <ul>
                    <li>Mancuernas de 3, 5, 8 y 10 lbs</li>
                    <li>Banda de resistencia circular</li>
                    <li>Tapete</li>
                    <li>Mini ball de pilates sin peso (aprox. 25 cm de diámetro)</li>
                    <li>Barra o una superficie estable donde puedas apoyarte</li>
                    <li>Polainas de 2 kg cada una (opcionales)</li>
                    <li>2 blocks de corcho (obligatorios) de 10 x 15 x 22 cm</li>
                    <li>Liga larga de látex (opcional)</li>
                  </ul>
                  <b>En vivo (vía Zoom o parte on demand)</b>
                  <ul>
                    <li>Mancuernas de 3, 5, 8 y 10 lbs</li>
                    <li>Banda de resistencia circular</li>
                    <li>Tapete</li>
                    <li>Mini ball de pilates sin peso (aprox. 25 cm de diámetro)</li>
                    <li>Barra o una superficie estable donde puedas apoyarte</li>
                    <li>Polainas de 2 kg cada una (opcionales)</li>
                    <li>2 blocks de corcho (obligatorios) de 10 x 15 x 22 cm</li>
                    <li>Liga larga de látex (opcional)</li>
                  </ul>
                  <p>Si tomas los 3 días en vivo de forma presencial en nuestro estudio, nosotras te prestamos todo el equipo durante ese fin de semana.</p>
                  </div>
                `,
  },
  {
    title: "¿En donde puedo tomar las certificaciones On Demand?",
    htmlContent:
      "Desde cualquier dispositivo electrónico que cuente con acceso a WIFI como: Android, iphone, laptop, ipad y smart TV.",
  },
  {
    title: "¿Cómo son las evaluaciones?",
    htmlContent: `
      <div>
        <p>En ambas modalidades, el proceso de evaluación incluye quizzes por módulo, evaluación práctica y examen final. Los quizzes se presentan entre módulo y módulo de cada disciplina y son necesarios para avanzar dentro del contenido.</p>
        <b>On demand</b>
        <p>Para completar tu certificación, es necesario cursar todos los quizzes de los módulos de cada una de las disciplinas en las que estés inscrita, completar todos los módulos correspondientes y presentar tanto el examen práctico como el examen final de cada disciplina en la que quieras certificarte.</p>
        <b>En vivo</b>
        <p>En esta modalidad también es necesario cursar todos los quizzes de los módulos de cada una de las disciplinas incluidas, así como completar todos sus módulos. En el examen práctico, puedes elegir una sola disciplina para presentar y, cumpliendo con los demás requisitos del proceso, certificarte en las 3 disciplinas.</p>
        <p>En ambas modalidades, al presentar tu examen final recibes una retroalimentación detallada para ayudarte a mejorar y seguir fortaleciendo tu formación.</p>
      </div>`,
  },
  {
    title: "¿El tomar la certificación me garantiza certificarme?",
    htmlContent:
      "No. Tomar la certificación no garantiza la aprobación. Para obtener tu certificación, es necesario concluir satisfactoriamente todos los quizzes teóricos de cada módulo y presentar el examen final práctico, que será evaluado por tu Master Coach. Al finalizar, recibirás retroalimentación sobre tu desempeño. La calificación mínima aprobatoria es de 70.",
  },
  {
    title: "¿Qué pasa si repruebo el examen final?",
    htmlContent:
      "Si no apruebas el examen final, cuentas con dos opciones: solicitar un segundo intento o recibir un diploma de participación. Si eliges un nuevo intento, activaremos 40 días adicionales de acceso a la plataforma on demand para que puedas repasar el contenido y volver a presentar tu examen. Tienes 30 días para elegir una de estas dos opciones. Si no recibimos tu respuesta dentro de ese plazo, se asumirá automáticamente que optas por el diploma de participación. En caso de no aprobar el segundo intento, se emitirá automáticamente un diploma de participación.",
  },
  {
    title: "Si no apruebo, ¿recibo un reembolso?",
    htmlContent:
      "No ofrecemos reembolsos en ningún caso. El costo de la certificación incluye el acceso al material de apoyo, la plataforma de aprendizaje y la asesoría de nuestras Master Coaches durante todo tu proceso de formación, independientemente del resultado obtenido.",
  },
  {
    title:
      "¿Qué pasa si me inscribo a una certificación En Vivo y no puedo tomarla en esas fechas?",
    htmlContent:
      "Si te inscribes a una certificación en vivo y no puedes tomarla en la fecha seleccionada, podrás reprogramarla hasta en dos ocasiones, siempre dentro de las próximas dos fechas publicadas. Para solicitar el cambio, es necesario que nos contactes vía WhatsApp con al menos 7 días de anticipación a la fecha de tu certificación. Una vez pasado este plazo, no será posible solicitar la reprogramación.",
  },
  {
    title:
      "¿Qué pasa si se expira mi acceso a las certificaciones on demand y aun no he terminado los módulos o cargado mis exámenes finales?",
    htmlContent: `
      <div>
        <p>Si tu acceso a la certificación on demand expira y aún no has terminado tus módulos o cargado tus exámenes finales, podrás solicitar una extensión de plazo hasta en 3 ocasiones:</p>
        <ul>
          <li>1ª extensión: 3 semanas adicionales por $500 MXN</li>
          <li>2ª extensión: 3 semanas adicionales por el 15% del valor de la certificación cursada</li>
          <li>3ª y última extensión: 3 semanas adicionales por el 50% del valor de la certificación cursada</li>
        </ul>
        <p>La solicitud debe realizarse dentro de los 30 días posteriores al vencimiento de tu acceso. Una vez transcurrido ese plazo, no será posible solicitar una prórroga.</p>
      </div>`,
  },
  {
    title:
      "¿Qué pasa si tengo un inconveniente para cargar mi examen el último día que tengo para subirlo?",
    htmlContent:
      "Nuestro horario de atención es de 9:00 a.m. a 6:00 p.m. (hora del centro de México, GMT-6). Si tienes algún inconveniente para cargar tu examen el último día que tienes para subirlo y solicitas atención vía WhatsApp fuera de ese horario, no podremos apoyarte a tiempo y, si no se logra cargar el examen, se tomará como fecha de entrega vencida. Te recomendamos no dejar la carga de tu examen para el último día y contactarnos dentro de nuestro horario de atención.",
  },
  {
    title:
      "Al aprobar el examen teórico y práctico ¿Cómo recibo mi certificado?",
    htmlContent:
      "Una vez que cargues tu examen final, contamos con hasta 40 días hábiles para evaluarlo (los fines de semana y días de asueto no se consideran días hábiles). Después de recibir tus resultados, tu certificado digital y guía se cargarán dentro de los siguientes 15 días. El envío físico se realizará en los días posteriores, una vez que tu paquete esté listo. Dentro de México, el envío es gratuito. Si vives fuera del país, el envío tendrá un costo adicional.",
  },
  {
    title:
      "¿Puedo utilizar el nombre de TBM, The Body Method o TBM Certifications?",
    htmlContent:
      'El uso de la marca TBM, The Body Method, TBM Certifications, así como de sus nombres comerciales, disciplinas, elementos distintivos, identidad visual y demás activos de propiedad intelectual, se encuentra reservado exclusivamente a TBM y no podrá ser utilizado sin autorización previa y por escrito. La alumna certificada podrá únicamente hacer mención informativa de haber cursado y aprobado una certificación de TBM. Asimismo, podrá utilizar el nombre de las disciplinas únicamente si cuenta con la certificación correspondiente y siempre que lo haga acompañado de la leyenda "by TBM". Por ejemplo: Sculpt and Burn by TBM y Block Burn Pilates by TBM.',
  },
  {
    title: "¿Cuánto tiempo necesito dedicarle a la certificación?",
    htmlContent: `
      <div>
        <p>El tiempo que dediques a la certificación dependerá de tu ritmo y disponibilidad. La modalidad On Demand está diseñada para que puedas avanzar en tus propios horarios; estos tiempos son únicamente una guía sugerida.</p>
        <b>Sculpt &amp; Burn</b>
        <ul>
          <li>Duración total de videos: 8 h 44 min</li>
          <li>Tiempo recomendado de dedicación total: aproximadamente 16 horas</li>
          <li>Sugerencia: 5 días por semana, 50 minutos al día, durante 4 semanas</li>
        </ul>
        <b>Barre</b>
        <ul>
          <li>Duración total de videos: 5 h 6 min</li>
          <li>Tiempo recomendado de dedicación total: aproximadamente 10 horas</li>
          <li>Sugerencia: 5 días por semana, 60 minutos al día, durante 2 semanas</li>
        </ul>
        <b>Block Burn Pilates</b>
        <ul>
          <li>Duración total de videos: 14 horas</li>
          <li>Tiempo recomendado de dedicación total: aproximadamente 18 horas</li>
          <li>Sugerencia: 5 días por semana, 55 minutos al día, durante 4 semanas</li>
        </ul>
        <p>Estos tiempos incluyen no solo ver los videos, sino también repetir prácticas, estudiar el manual y repasar el contenido.</p>
      </div>`,
  },
  {
    title: "¿Puedo cambiarme de modalidad después de inscribirme?",
    htmlContent: `
      <div>
        <b>On demand</b>
        <p>Sí. Después de realizar tu compra, cuentas con 7 días naturales para solicitar un cambio de paquete y pagar únicamente la diferencia en caso de querer agregar más disciplinas. No es posible reducir la cantidad de disciplinas ni cambiar a un paquete de menor valor una vez realizada la inscripción.</p>
        <b>En vivo</b>
        <p>Si elegiste la modalidad presencial y deseas cambiar a Zoom, deberás solicitarlo con al menos 2 semanas de anticipación a la fecha de tu certificación, ya que los lugares presenciales son limitados y están sujetos a alta demanda. Si la solicitud se realiza fuera de ese plazo, no podremos garantizar el cambio de modalidad. En caso de no asistir, TBM se reserva el derecho de ofrecer únicamente el acceso on demand de las 3 disciplinas o, en su caso, dar por perdida la certificación.</p>
      </div>`,
  },
];
